import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-page',
  templateUrl: './header-page.component.html',
  styleUrls: ['./header-page.component.scss']
})
export class HeaderPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  globalSearch(): void {
    const searchKey = document.getElementById('searchKey') as HTMLInputElement;
    window.location.href = ('https://ihsmarkit.com/search/results.html?search=' + searchKey.value);
  }
}
